import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup, NgForm } from '@angular/forms';
import { CoreSidebarService } from '@core/components/core-sidebar/core-sidebar.service';
import { RoleService } from 'app/services/models/role.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-new-role-sidebar',
  templateUrl: './new-role-sidebar.component.html',
  encapsulation:ViewEncapsulation.None
})
export class NewRoleSidebarComponent implements OnInit {

  constructor(private _coreSidebarService: CoreSidebarService,private roleService:RoleService,private toastService:ToastrService) { }

  ngOnInit(): void {
  }
  public rolName;

  toggleSidebar(name): void {
    this._coreSidebarService.getSidebarRegistry(name).toggleOpen();
  }

  async submit(form:NgForm) {
    if (form.valid) {
    
      this.toggleSidebar('new-role-sidebar');
    
      const data = await this.roleService.createRole(this.rolName);
      console.log(data);
      if(data==true){
        this.toastService.success(data.message);
        
      }
      else
        this.toastService.error(data.message);
      
    }
  }
  
}
